import {
	JSON_FORM,
	TOGGLE_JSON_TREE,
	PREVIOUS,
	BACK_JSONTREE_QUESTION,
	UPDATE_CURRENT_QUESTION_TREE_ID,
} from '#app/constants/forms.ts'
import { type GlobalFormStore } from '../reducer/createGlobalFormStore.ts'

interface HandlePreviousButtonClickParams<T> {
	dispatch: Function
	entireGlobalState: GlobalFormStore<T>
}

export function handlePreviousButtonClick<T>({
	dispatch,
	entireGlobalState,
}: HandlePreviousButtonClickParams<T>) {
	const { type } = entireGlobalState

	if (type === JSON_FORM) {
		const {
			isInJsonTree,
			answeredQuestionsStack,
			currentQuestionId,
			currentQuestionTreeId,
			questionTree,
		} = entireGlobalState

		if (isInJsonTree) {
			let currentStackItem = answeredQuestionsStack.find(
				item => item.id === currentQuestionTreeId,
			)

			if (
				currentStackItem &&
				currentStackItem.answers.includes(currentQuestionId)
			) {
				currentStackItem.answers.pop()
			}

			if (currentStackItem && currentStackItem.answers.length > 0) {
				const previousQuestionId =
					currentStackItem.answers[currentStackItem.answers.length - 1]

				dispatch({ type: BACK_JSONTREE_QUESTION, previousQuestionId })
			} else {
				const currentTree = questionTree.find(
					tree => tree.id === currentQuestionTreeId,
				)

				const currentTreeHasParent = currentTree?.tree?.isChildOf || null

				const parentIsAnJsonTree = answeredQuestionsStack.find(
					item => item.id === currentTreeHasParent,
				)

				if (currentTreeHasParent && parentIsAnJsonTree) {
					dispatch({
						type: UPDATE_CURRENT_QUESTION_TREE_ID,
						currentQuestionTreeId: currentTreeHasParent,
					})
				} else {
					dispatch({ type: TOGGLE_JSON_TREE, isInJsonTree: false })
				}

				dispatch({ type: PREVIOUS })
			}
		} else {
			dispatch({ type: PREVIOUS })
		}
	} else {
		dispatch({ type: PREVIOUS })
	}
}
